import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "my-info-page toggleswitch" }
const _hoisted_2 = { class: "my-info-header" }
const _hoisted_3 = { class: "my-info-title-wrap" }
const _hoisted_4 = { class: "my-info-title" }
const _hoisted_5 = { class: "my-info-toolbar" }
const _hoisted_6 = { class: "my-info-header-actions" }
const _hoisted_7 = { class: "btn btn-secondary btn-size-header-main" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "my-info-description" }
const _hoisted_11 = { class: "my-info-table-wrapper" }
const _hoisted_12 = { class: "my-info-table" }
const _hoisted_13 = { class: "col-field" }
const _hoisted_14 = { class: "col-associated" }
const _hoisted_15 = { class: "col-source" }
const _hoisted_16 = { class: "col-visible" }
const _hoisted_17 = { class: "col-field" }
const _hoisted_18 = { class: "col-associated" }
const _hoisted_19 = { class: "col-source color-grey" }
const _hoisted_20 = { class: "col-visible" }
const _hoisted_21 = { class: "switch" }
const _hoisted_22 = ["checked", "onChange"]
const _hoisted_23 = { class: "col-kebab" }
const _hoisted_24 = { class: "kebab-cell" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "drawer-form-group" }
const _hoisted_29 = { class: "drawer-label" }
const _hoisted_30 = { class: "drawer-form-group" }
const _hoisted_31 = { class: "drawer-checkbox-label" }
const _hoisted_32 = { class: "drawer-form-group" }
const _hoisted_33 = { class: "drawer-label" }
const _hoisted_34 = { class: "drawer-form-group" }
const _hoisted_35 = { class: "drawer-checkbox-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalPopup = _resolveComponent("ModalPopup")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_SideDrawer = _resolveComponent("SideDrawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showModalPopup)
      ? (_openBlock(), _createBlock(_component_ModalPopup, {
          key: 0,
          "show-modal-popup": _ctx.showModalPopup,
          "header-content": _ctx.modalPopupHeading,
          "body-heading": _ctx.modalPopupBodyHeading,
          "body-content": _ctx.modalPopupBodyContent,
          "show-cancel-button": _ctx.modalPopupShowCancelButton,
          "cancel-button-text": _ctx.modalPopupCancelButtonText,
          "confirm-button-text": _ctx.modalPopupConfirmButtonText,
          "show-close-button": _ctx.showCloseButton,
          "image-url": _ctx.deletePopupIcon,
          onConfirmClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ConfirmClick($event)))
        }, null, 8, ["show-modal-popup", "header-content", "body-heading", "body-content", "show-cancel-button", "cancel-button-text", "confirm-button-text", "show-close-button", "image-url"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('MyInformation.Title')), 1),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "my-info-title-underline" }, null, -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", _hoisted_7, [
          _createElementVNode("img", {
            src: _ctx.exportIcon,
            class: "menu-item-icon"
          }, null, 8, _hoisted_8),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('MyInformation.Export')), 1)
        ]),
        _createElementVNode("button", {
          class: "btn btn-primary btn-size-header-main",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.OpenAddDrawer && _ctx.OpenAddDrawer(...args)))
        }, [
          _createElementVNode("img", { src: _ctx.addIcon }, null, 8, _hoisted_9),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('MyInformation.AddField')), 1)
        ])
      ])
    ]),
    _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('MyInformation.Description')), 1),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("table", _hoisted_12, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _cache[11] || (_cache[11] = _createElementVNode("th", { class: "col-drag" }, null, -1)),
            _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('MyInformation.Field')), 1),
            _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('MyInformation.ParticipantsAssociated')), 1),
            _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('MyInformation.Source')), 1),
            _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('MyInformation.VisibleInApp')), 1),
            _cache[12] || (_cache[12] = _createElementVNode("th", { class: "col-kebab" }, null, -1))
          ])
        ]),
        _createVNode(_component_draggable, {
          list: _ctx.myInformationListData,
          tag: "tbody",
          handle: ".drag-handle",
          "ghost-class": "drag-ghost",
          onEnd: _ctx.OnDragEnd
        }, {
          default: _withCtx(() => [
            _createVNode(_TransitionGroup, { type: "transition" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myInformationListData, (field) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: field.Id,
                    class: "my-info-row"
                  }, [
                    _cache[14] || (_cache[14] = _createElementVNode("td", { class: "col-drag" }, [
                      _createElementVNode("span", { class: "drag-handle" }, [
                        _createElementVNode("svg", {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 24 24",
                          fill: "currentColor",
                          class: "drag-icon"
                        }, [
                          _createElementVNode("circle", {
                            cx: "9",
                            cy: "5",
                            r: "1.5"
                          }),
                          _createElementVNode("circle", {
                            cx: "15",
                            cy: "5",
                            r: "1.5"
                          }),
                          _createElementVNode("circle", {
                            cx: "9",
                            cy: "12",
                            r: "1.5"
                          }),
                          _createElementVNode("circle", {
                            cx: "15",
                            cy: "12",
                            r: "1.5"
                          }),
                          _createElementVNode("circle", {
                            cx: "9",
                            cy: "19",
                            r: "1.5"
                          }),
                          _createElementVNode("circle", {
                            cx: "15",
                            cy: "19",
                            r: "1.5"
                          })
                        ])
                      ])
                    ], -1)),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(field.KeyValue), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(field.ParticipantsCount), 1),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(field.Source), 1),
                    _createElementVNode("td", _hoisted_20, [
                      _createElementVNode("label", _hoisted_21, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: field.IsVisibleInApp,
                          onChange: ($event: any) => (_ctx.OnToggleVisible(field))
                        }, null, 40, _hoisted_22),
                        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "slider round" }, null, -1))
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("button", {
                          class: "kebab-btn",
                          onClick: _withModifiers(($event: any) => (_ctx.ToggleFieldMenu(field.Id, $event)), ["stop"])
                        }, " ⋮ ", 8, _hoisted_25),
                        (_ctx.openMenuId === field.Id)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["field-dropdown", { 'field-dropdown--above': _ctx.dropdownAbove }])
                            }, [
                              _createElementVNode("div", {
                                class: "field-dropdown-item padding-bottom-10",
                                onClick: ($event: any) => (_ctx.OpenEditDrawer(field))
                              }, _toDisplayString(_ctx.$t('Edit')), 9, _hoisted_26),
                              _createElementVNode("div", {
                                class: "field-dropdown-item field-dropdown-item--danger",
                                onClick: ($event: any) => (_ctx.ShowDeletePopup(field))
                              }, _toDisplayString(_ctx.$t('Delete')), 9, _hoisted_27)
                            ], 2))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["list", "onEnd"])
      ])
    ]),
    _createVNode(_component_SideDrawer, {
      "show-drawer": _ctx.showAddDrawer,
      title: _ctx.$t('MyInformation.AddDrawerTitle'),
      "confirm-button-text": _ctx.$t('MyInformation.AddButton'),
      "confirm-disabled": _ctx.drawerFieldName.trim() === '',
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showAddDrawer = false)),
      onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showAddDrawer = false)),
      onConfirm: _ctx.ConfirmAdd
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('MyInformation.Field')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.drawerFieldName) = $event)),
            type: "text",
            class: "form-control"
          }, null, 512), [
            [_vModelText, _ctx.drawerFieldName]
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("label", _hoisted_31, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.drawerHideFromApp) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, _ctx.drawerHideFromApp]
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('MyInformation.HideFromApp')), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["show-drawer", "title", "confirm-button-text", "confirm-disabled", "onConfirm"]),
    _createVNode(_component_SideDrawer, {
      "show-drawer": _ctx.showEditDrawer,
      title: _ctx.$t('MyInformation.EditDrawerTitle'),
      "confirm-disabled": _ctx.drawerFieldName.trim() === '',
      onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showEditDrawer = false)),
      onCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showEditDrawer = false)),
      onConfirm: _ctx.ConfirmEdit
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('MyInformation.Field')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.drawerFieldName) = $event)),
            type: "text",
            class: "form-control"
          }, null, 512), [
            [_vModelText, _ctx.drawerFieldName]
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("label", _hoisted_35, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.drawerHideFromApp) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, _ctx.drawerHideFromApp]
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('MyInformation.HideFromApp')), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["show-drawer", "title", "confirm-disabled", "onConfirm"])
  ]))
}